import { ArrowRight, Sparkles, ChevronDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden"
    >
      {/* overlays only — background DNA video shows through */}
      <div className="absolute inset-0 bg-grid opacity-25 z-10 pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-[#030508]/80 z-10 pointer-events-none" />

      {/* Side rails */}
      <div className="hidden md:flex absolute top-0 left-6 h-full w-px bg-gradient-to-b from-transparent via-[#00F0FF]/30 to-transparent z-20" />
      <div className="hidden md:flex absolute top-0 right-6 h-full w-px bg-gradient-to-b from-transparent via-[#D900FF]/30 to-transparent z-20" />

      {/* Top-right HUD label */}
      <div className="hidden md:flex absolute top-24 right-10 z-20 items-center gap-2 font-mono-ui text-[10px] tracking-[0.3em] uppercase text-white/50">
        <span className="w-2 h-2 rounded-full bg-[#00FF66] pulse-dot" />
        Live · CELL.SYS / 144.000 GHZ
      </div>

      {/* Hero content */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-10 min-h-screen flex flex-col justify-center pt-24 pb-20">
        <div className="max-w-3xl fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-[#00F0FF]/40 bg-[#00F0FF]/5 backdrop-blur-sm mb-8">
            <Sparkles className="w-3 h-3 text-[#00F0FF]" />
            <span className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-[#00F0FF]">
              X39 ∙ Phototherapy patch
            </span>
          </div>

          <h1 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-7xl xl:text-8xl">
            Activate
            <br />
            <span className="text-[#00F0FF] glow-cyan">your stem</span>
            <br />
            cells.
          </h1>

          <p className="mt-8 max-w-xl text-base sm:text-lg text-white/70 leading-relaxed">
            LifeWave STEMCELL™ X39 uses precise wavelengths of light to elevate
            a copper peptide naturally produced by your body — supporting
            regeneration, energy, sleep & vitality from your very first day.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#product"
              data-testid="hero-primary-cta"
              className="btn-neon group inline-flex items-center gap-3 px-7 py-4 bg-[#00F0FF] text-black font-mono-ui text-xs tracking-[0.3em] uppercase font-bold hover:bg-white hover:shadow-[0_0_40px_#00F0FF] transition-all"
            >
              Discover X39
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#science"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center gap-3 px-7 py-4 border border-white/20 text-white font-mono-ui text-xs tracking-[0.3em] uppercase font-bold hover:border-[#00F0FF] hover:text-[#00F0FF] transition-all"
            >
              The Science
            </a>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-6 max-w-lg">
            <Metric value="200K+" label="Patches sold daily" />
            <Metric value="80+" label="Countries served" />
            <Metric value="20yr" label="Of research" />
          </div>
        </div>
      </div>

      {/* scroll cue */}
      <a
        href="#science"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-white/40 hover:text-[#00F0FF] transition-colors"
        data-testid="hero-scroll-cue"
      >
        <span className="font-mono-ui text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <ChevronDown className="w-4 h-4 animate-bounce" />
      </a>
    </section>
  );
}

function Metric({ value, label }) {
  return (
    <div>
      <div className="font-display font-black text-2xl text-white">{value}</div>
      <div className="mt-1 font-mono-ui text-[10px] tracking-[0.25em] uppercase text-white/40">
        {label}
      </div>
    </div>
  );
}
